var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDesarrollo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 67.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .q {\n        clip-path: url(#j);\n      }\n\n      .q, .r, .s {\n        fill: none;\n      }\n\n      .t {\n        fill: #fff;\n      }\n\n      .u {\n        fill: #f5f5f5;\n      }\n\n      .r {\n        isolation: isolate;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 250,
    height: 39.33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "Group 3500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e",
    "data-name": "Interactive car studio",
    className: "r"
  }, /*#__PURE__*/React.createElement("g", {
    className: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m.94,53.73h3.12v13.6H.94v-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m6.7,53.73h2.72l6.78,8.44v-8.44h3.12v13.6h-2.7l-6.8-8.44v8.44h-3.12v-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m24.9,56.43h-4.02v-2.7h11.16v2.7h-4.02v10.9h-3.12v-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m33.6,53.73h9.8v2.7h-6.68v2.68h5.7v2.7h-5.7v2.82h6.68v2.7h-9.8v-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m50.22,62.05h-1.62v5.28h-3.12v-13.6h6.3c.65,0,1.26.1,1.81.29.55.19,1.03.47,1.44.83.41.36.72.8.95,1.31s.34,1.09.34,1.73c0,.97-.25,1.8-.76,2.47-.51.67-1.18,1.15-2.02,1.43l4.16,5.48v.06h-3.7l-3.78-5.28Zm1.22-2.7c.56,0,.98-.13,1.25-.39s.41-.62.41-1.07-.14-.81-.41-1.07-.69-.39-1.25-.39h-2.84v2.92h2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m62.64,53.73h3.72l5.18,13.6h-3.22l-.96-2.6h-5.72l-.96,2.6h-3.22l5.18-13.6Zm0,8.3h3.72l-1.86-5.04-1.86,5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m78.56,67.63c-1.03,0-1.97-.18-2.82-.53-.85-.35-1.59-.84-2.21-1.47s-1.1-1.38-1.45-2.25-.52-1.82-.52-2.85.17-1.97.52-2.84c.35-.87.83-1.62,1.45-2.25.62-.63,1.36-1.13,2.21-1.48s1.79-.53,2.82-.53c1.44,0,2.67.29,3.69.87,1.02.58,1.84,1.36,2.45,2.35l-2.3,1.74c-.43-.64-.93-1.15-1.5-1.52s-1.33-.56-2.28-.56c-.6,0-1.14.11-1.61.32-.47.21-.87.51-1.2.89-.33.38-.58.83-.76,1.34-.18.51-.27,1.07-.27,1.67s.09,1.16.27,1.67c.18.51.43.96.76,1.34.33.38.73.68,1.2.89.47.21,1.01.32,1.61.32.95,0,1.71-.19,2.28-.56s1.07-.88,1.5-1.52l2.3,1.74c-.61.99-1.43,1.77-2.45,2.35-1.02.58-2.25.87-3.69.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m89.26,56.43h-4.02v-2.7h11.16v2.7h-4.02v10.9h-3.12v-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m97.96,53.73h3.12v13.6h-3.12v-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m102.3,53.73h3.22l3.62,10.22,3.62-10.22h3.22l-4.98,13.6h-3.72l-4.98-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m117.2,53.73h9.8v2.7h-6.68v2.68h5.7v2.7h-5.7v2.82h6.68v2.7h-9.8v-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m139.4,67.63c-1.03,0-1.97-.18-2.82-.53-.85-.35-1.59-.84-2.21-1.47-.62-.63-1.1-1.38-1.45-2.25-.35-.87-.52-1.82-.52-2.85s.17-1.97.52-2.84c.35-.87.83-1.62,1.45-2.25.62-.63,1.36-1.13,2.21-1.48.85-.35,1.79-.53,2.82-.53,1.44,0,2.67.29,3.69.87,1.02.58,1.84,1.36,2.45,2.35l-2.3,1.74c-.43-.64-.93-1.15-1.5-1.52s-1.33-.56-2.28-.56c-.6,0-1.14.11-1.61.32-.47.21-.87.51-1.2.89-.33.38-.58.83-.76,1.34-.18.51-.27,1.07-.27,1.67s.09,1.16.27,1.67.43.96.76,1.34c.33.38.73.68,1.2.89.47.21,1.01.32,1.61.32.95,0,1.71-.19,2.28-.56s1.07-.88,1.5-1.52l2.3,1.74c-.61.99-1.43,1.77-2.45,2.35-1.02.58-2.25.87-3.69.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m150.7,53.73h3.72l5.18,13.6h-3.22l-.96-2.6h-5.72l-.96,2.6h-3.22l5.18-13.6Zm0,8.3h3.72l-1.86-5.04-1.86,5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m165.52,62.05h-1.62v5.28h-3.12v-13.6h6.3c.65,0,1.26.1,1.81.29.55.19,1.03.47,1.44.83.41.36.72.8.95,1.31s.34,1.09.34,1.73c0,.97-.25,1.8-.76,2.47-.51.67-1.18,1.15-2.02,1.43l4.16,5.48v.06h-3.7l-3.78-5.28Zm1.22-2.7c.56,0,.98-.13,1.25-.39s.41-.62.41-1.07-.14-.81-.41-1.07-.69-.39-1.25-.39h-2.84v2.92h2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m183.08,67.63c-.81,0-1.53-.09-2.16-.27-.63-.18-1.18-.42-1.67-.71-.49-.29-.9-.62-1.25-.97-.35-.35-.65-.71-.9-1.07l1.98-2.02c.2.29.43.58.69.85s.56.52.89.73c.33.21.71.38,1.12.51.41.13.87.19,1.36.19.71,0,1.24-.15,1.6-.44.36-.29.54-.65.54-1.08,0-.16-.03-.31-.08-.46-.05-.15-.15-.28-.29-.41-.14-.13-.33-.24-.58-.34-.25-.1-.56-.18-.95-.23l-1.08-.16c-.63-.09-1.2-.25-1.71-.47-.51-.22-.95-.5-1.32-.84-.37-.34-.65-.73-.85-1.18-.2-.45-.3-.94-.3-1.49,0-.61.12-1.19.35-1.72s.57-.99,1.01-1.38c.44-.39.97-.69,1.6-.91.63-.22,1.33-.33,2.1-.33,1.07,0,2.03.2,2.88.6.85.4,1.54.92,2.06,1.56l-1.92,2.08c-.43-.47-.9-.83-1.42-1.09-.52-.26-1.07-.39-1.66-.39s-1,.13-1.31.38c-.31.25-.47.54-.47.86s.12.58.36.81c.24.23.63.39,1.16.47l1.08.16c1.45.21,2.58.68,3.37,1.39.79.71,1.19,1.67,1.19,2.87,0,.68-.14,1.3-.41,1.85s-.65,1.03-1.13,1.42c-.48.39-1.05.7-1.71.91s-1.38.32-2.17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m192.96,56.43h-4.02v-2.7h11.16v2.7h-4.02v10.9h-3.12v-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m207.42,67.63c-1.01,0-1.89-.16-2.63-.47-.74-.31-1.35-.75-1.84-1.3-.49-.55-.85-1.2-1.09-1.95-.24-.75-.36-1.56-.36-2.44v-7.74h3.12v7.56c0,.51.05.97.14,1.4.09.43.25.79.47,1.1.22.31.51.54.87.71.36.17.8.25,1.32.25s.96-.08,1.31-.25c.35-.17.64-.4.86-.71.22-.31.38-.67.48-1.1.1-.43.15-.89.15-1.4v-7.56h3.12v7.74c0,.88-.12,1.69-.36,2.44-.24.75-.6,1.4-1.09,1.95-.49.55-1.1.99-1.84,1.3-.74.31-1.62.47-2.63.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m215.82,53.73h5.72c1,0,1.92.15,2.76.44.84.29,1.56.73,2.17,1.31s1.08,1.29,1.42,2.14c.34.85.51,1.82.51,2.91s-.17,2.08-.51,2.92-.81,1.55-1.42,2.13-1.33,1.02-2.17,1.31-1.76.44-2.76.44h-5.72v-13.6Zm3.12,2.72v8.16h2.46c1.17,0,2.1-.35,2.77-1.04.67-.69,1.01-1.71,1.01-3.04s-.34-2.35-1.01-3.04c-.67-.69-1.6-1.04-2.77-1.04h-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m230.36,53.73h3.12v13.6h-3.12v-13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m242.4,67.63c-1.03,0-1.97-.18-2.82-.53-.85-.35-1.59-.84-2.21-1.47-.62-.63-1.1-1.38-1.45-2.25-.35-.87-.52-1.82-.52-2.85s.17-1.97.52-2.84c.35-.87.83-1.62,1.45-2.25.62-.63,1.36-1.13,2.21-1.48.85-.35,1.79-.53,2.82-.53s1.95.18,2.81.53c.86.35,1.6.85,2.22,1.48.62.63,1.1,1.38,1.45,2.25.35.87.52,1.81.52,2.84s-.17,1.98-.52,2.85c-.35.87-.83,1.62-1.45,2.25s-1.36,1.12-2.22,1.47c-.86.35-1.8.53-2.81.53Zm0-2.88c.6,0,1.13-.11,1.6-.32.47-.21.86-.51,1.18-.89.32-.38.57-.83.74-1.34.17-.51.26-1.07.26-1.67s-.09-1.16-.26-1.67c-.17-.51-.42-.96-.74-1.34-.32-.38-.71-.68-1.18-.89-.47-.21-1-.32-1.6-.32s-1.13.11-1.6.32-.86.51-1.18.89c-.32.38-.57.83-.74,1.34-.17.51-.26,1.07-.26,1.67s.09,1.16.26,1.67c.17.51.42.96.74,1.34.32.38.71.68,1.18.89.47.21,1,.32,1.6.32Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "f",
    "data-name": "Group 3533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "g",
    "data-name": "Path 1407",
    className: "u",
    d: "m25.8,0v15.22H8.83V0H0v38.48h8.83v-15.62h16.97v15.62h8.83V0h-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    "data-name": "Path 1408",
    className: "u",
    d: "m65.13,0l-8.32,14.09L48.49,0h-10.36v.17l14.26,22.47v15.84h8.83v-15.84L75.49.17v-.17h-10.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i",
    "data-name": "Group 3534"
  }, /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k",
    "data-name": "Group 3533-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l",
    "data-name": "Path 1409",
    className: "u",
    d: "m95.29,39.33c-2.54.06-5.07-.39-7.44-1.33-1.99-.81-3.77-2.07-5.21-3.68-1.4-1.61-2.45-3.49-3.08-5.52-.7-2.23-1.04-4.56-1.02-6.9V0h8.83v21.39c0,1.33.12,2.66.4,3.96.22,1.12.68,2.18,1.33,3.11.63.87,1.48,1.57,2.46,2.01,1.18.5,2.45.74,3.74.71,1.27.04,2.54-.2,3.71-.71.97-.45,1.81-1.14,2.43-2.01.65-.94,1.12-2,1.36-3.11.29-1.3.44-2.63.43-3.96V0h8.83v21.9c.02,2.34-.32,4.67-1.02,6.9-.63,2.03-1.68,3.91-3.08,5.52-1.43,1.61-3.22,2.87-5.21,3.68-2.37.94-4.9,1.39-7.44,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    "data-name": "Path 1410",
    className: "u",
    d: "m119.06,0h7.7l19.18,23.88V0h8.83v38.48h-7.64l-19.24-23.88v23.88h-8.83V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    "data-name": "Path 1411",
    className: "u",
    d: "m162.23,0h16.18c2.65-.03,5.29.39,7.81,1.25,2.29.78,4.38,2.04,6.14,3.71,1.76,1.71,3.13,3.77,4.02,6.06,1,2.63,1.49,5.42,1.44,8.23.06,2.82-.43,5.63-1.44,8.26-.89,2.27-2.26,4.33-4.02,6.03-1.75,1.66-3.85,2.93-6.14,3.71-2.51.85-5.15,1.27-7.81,1.24h-16.18V0Zm8.83,7.7v23.08h6.96c2.91.16,5.75-.91,7.84-2.94,1.9-1.96,2.86-4.83,2.86-8.6,0-3.77-.95-6.64-2.86-8.6-2.09-2.03-4.93-3.1-7.84-2.94h-6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    "data-name": "Path 1412",
    className: "u",
    d: "m212.65,0h10.52l14.66,38.48h-9.11l-2.72-7.36h-16.18l-2.72,7.36h-9.11L212.65,0Zm0,23.48h10.52l-5.26-14.26-5.26,14.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "p",
    "data-name": "Rectangle 1916",
    className: "u",
    x: 241.17,
    width: 8.83,
    height: 38.48
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDesarrollo);
export default __webpack_public_path__ + "static/media/logo_desarrollo.935e333d6a998fb0780ffbf4587054b3.svg";
export { ForwardRef as ReactComponent };